<template>
  <div>
    <div
      class="description-text tender-font"
      v-show="description"
    >{{ description }}</div>
    <p
      class="hint"
      v-if="showTenderHints"
    >{{ $t('tender.attachment.attachmentNotes') }}</p>
    <table
      class="tender-tnc-table"
      v-show="files.length>0"
    >
      <thead>
        <th class="number tender-font">#</th>
        <th class="filename tender-font">{{ $t('tender.attachment.document') }}</th>
        <th class="description tender-font">{{ $t('tender.attachment.description') }}</th>
      </thead>
      <tbody>
        <template v-for="(item, index) in sortedFiles">
          <tr
            class="set-border-top"
            :class="highlightForAddendumChange(item)"
          >
            <td class="number tender-font">{{ index + 1 }}</td>
            <td class="filename tender-font">
              <a
                style="text-decoration: underline;"
                @click="downloadFile(item.id)"
                target="terms_conditions"
              >{{ item.filename }}</a>
            </td>
            <td class="description tender-font">
              <div class="description-text">{{ item.description }}</div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <div
      class="tnc-download-all clearfix"
      v-show="files.length > 0"
    >
      <button
        type="button"
        class="btn btn--orange tender-sticky-button float-right"
        @click="downloadAll()"
      >{{ $t('action.downloadAll') }}</button>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import * as xfs from '@/utils/xfs'
import { mapState, mapGetters } from 'vuex'
import { addendumChangeType } from '@/utils/locale'
import querystring from 'querystring'

export default {

  props: {
    files: {
      type: Array,
      default: () => [],
    },
    description: {
      type: String,
    },
    noHighlight: {
      type: Boolean,
      default: false,
    },
    showTenderHints: {
      type: Boolean,
      default: false,
    },
    zipName: {
      type: String,
      default: '',
    },
  },
  watch: {
    files () {
      this.$forceUpdate()
    },
  },
  methods: {
    async downloadFile (fileId) {
      await xfs.downloadFile(`/docs/${fileId}`)
    },

    async downloadAll () {
      const filesId = this.files.map(file => file.id)
      const query = querystring.stringify({docsId: filesId})
      await xfs.downloadFile(`/docs/all/${this.files[0].source}?${query}`, this.zipName)
    },

    highlightForAddendumChange (item) {
      if (this.noHighlight || !item || !this.isAddendum || !this.revisionHistoryData) return ''

      if (this.revisionHistoryData[item.id]) {
        const revisionData = this.revisionHistoryData[item.id]
        return (item.description !== revisionData.description)
          ? `${this.addendumClassName}-${addendumChangeType.updated}` : ''
      }
      return `${this.addendumClassName}-${addendumChangeType.added}`
    },

    buildRevisionHistoryData (revisionHistory) {
      if (!revisionHistory) {
        return null
      }

      const revisionHistoryData = {}
      revisionHistory.forEach((item) => {
        revisionHistoryData[item.id] = item
      })
      return revisionHistoryData
    },
  },
  computed: {
    ...mapState('tenders', {
      sortedFiles () {
        return lodash.orderBy(this.files, [
          ({metaData}) => metaData && metaData.category ? -1 : 1,
          'order',
        ])
      },
      addendumClassName (state) {
        return state.addendumClassName
      },
      recentRevisionDocuments (state) {
        return (state.recentRevisionHistory || {}).documents
      },

      revisionHistoryData () {
        return this.buildRevisionHistoryData(this.recentRevisionDocuments)
      },

    }),
    ...mapGetters('tenders', [
      'isAddendum',
      'currentTender',
    ]),
    tenderId () {
      return this.currentTender.general.id
    },
    tenderStatus () {
      return this.currentTender.general.status
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/tender/attachments';
@import '~styles/tender/addendum';

.hint {
  margin: 0 0 5px 0;
}
</style>
